import { render, staticRenderFns } from "./LogMessage.vue?vue&type=template&id=37416a8a&scoped=true&"
import script from "./LogMessage.vue?vue&type=script&lang=js&"
export * from "./LogMessage.vue?vue&type=script&lang=js&"
import style0 from "./LogMessage.vue?vue&type=style&index=0&id=37416a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37416a8a",
  null
  
)

export default component.exports